export const normalizePhone = (value) => (value || '').replace(/\D/g, '');

export const isMobilePhoneChanged = (originalMobile, currentMobile) =>
    normalizePhone(originalMobile) !== normalizePhone(currentMobile);

export const getOkToTextLabel = (okToText) => {
    if (okToText == null || okToText === '') {
        return null;
    }
    if (Number(okToText) === 1) {
        return 'Yes — consents to text at mobile phone';
    }
    if (Number(okToText) === 0) {
        return 'No — does not consent to text';
    }
    if (Number(okToText) === 2) {
        return 'No — does not have access to text';
    }
    return null;
};

export const flattenRpmDeviceOptions = (programsResponse, connectionType) => {
    const programs = (programsResponse && programsResponse.programs) || [];
    const isCellular = connectionType === 'cellular';

    return programs
        .filter((program) => !!program.cellular_enabled === isCellular)
        .reduce((options, program) => {
            const products = program.products || [];
            products.forEach((product) => {
                options.push({
                    id: product.id,
                    programId: program.id,
                    description: product.name,
                    programName: program.name,
                });
            });
            return options;
        }, []);
};

export const normalizeValidatedAddress = (address) => {
    const lines = (address && address.address_lines) || [];
    return {
        address1: lines[0] || '',
        address2: lines.length > 1 ? lines.slice(1).join(', ') : '',
        city: (address && address.city) || '',
        state: (address && address.state) || '',
        zip_code: (address && address.zip_code) || '',
    };
};

export const formatValidatedAddressLabel = (address) => {
    const shipping = normalizeValidatedAddress(address);
    const line2 = shipping.address2 ? `, ${shipping.address2}` : '';
    return `${shipping.address1}${line2}, ${shipping.city}, ${shipping.state} ${shipping.zip_code}`;
};

export const parseAddressValidationResponse = (result) => {
    if (!result) {
        return { status: 'invalid', error: 'Address validation failed.' };
    }

    const addresses = result.addresses || [];
    const ambiguousMatch = result.ambiguous_match === true;

    if (addresses.length === 0) {
        return {
            status: 'invalid',
            error: result.message || result.error || result.description || 'Invalid address. Address could not be verified.',
        };
    }

    if (addresses.length > 1) {
        return {
            status: 'selection_required',
            addresses,
            message: 'Multiple address matches found. Select the correct shipping address.',
        };
    }

    if (ambiguousMatch) {
        return {
            status: 'selection_required',
            addresses,
            message: 'Please confirm the shipping address below.',
        };
    }

    return {
        status: 'verified',
        shipping: normalizeValidatedAddress(addresses[0]),
        message: 'Address verified. Deliverable — ready to enroll.',
    };
};

export const buildRpmEnrollRequest = ({
    consentType,
    selectedDevice,
    shipping,
    connectionType,
    mobile,
}) => {
    const payload = {
        rpm_consent_type: consentType,
        rpm_program_id: selectedDevice.programId,
        rpm_device_id: selectedDevice.id,
        address1: shipping.address1,
        address2: shipping.address2 || '',
        city: shipping.city,
        state: shipping.state,
        zip_code: shipping.zip_code,
    };

    if (connectionType) {
        payload.is_bluetooth = connectionType === 'bluetooth';
    }

    if (connectionType === 'bluetooth' && mobile) {
        payload.mobile = normalizePhone(mobile);
    }

    return payload;
};

export const buildRpmEnrollPayload = ({
    consentType,
    selectedDevice,
    shipping,
    connectionType,
    mobile,
}) => buildRpmEnrollRequest({
    consentType,
    selectedDevice,
    shipping,
    connectionType,
    mobile,
});
